import { inspect } from 'util';
import stringify from 'safe-stable-stringify';
import { extractErrorMeta } from '../utils';
export const createStdOutLogger = (consoleInstance) => {
    const createHandler = (method) => (event, logEntity, metaData = {}) => {
        const isError = logEntity instanceof Error;
        const errorMeta = isError ? extractErrorMeta(logEntity, true) : {};
        const recordObject = typeof logEntity === 'string' ? {} : logEntity;
        const message = typeof logEntity === 'string' ? logEntity : inspect(logEntity);
        consoleInstance[method](stringify({
            event: String(event),
            message,
            ...{
                ...metaData,
                ...errorMeta,
                ...recordObject,
            },
        }, null, 0));
    };
    return {
        info: createHandler('info'),
        error: createHandler('error'),
        warn: createHandler('warn'),
        debug: createHandler('debug'),
    };
};
//# sourceMappingURL=index.js.map